// src/plugins/metaPixel.js
export default {
    install(Vue) {
      Vue.prototype.$metaPixel = {
        isEnabled: false,
        
        load(pixelId) {
          if (window.fbq) {
            this.isEnabled = true
            return
          }
          
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          
          window.fbq('init', pixelId);
          window.fbq('track', 'PageView');
          this.isEnabled = true
        },
        
        deleteFacebookCookies() {
          // Liste der Facebook/Meta Pixel Cookies
          const fbCookies = ['_fbp', '_fbc', 'fr', 'sb', 'datr', 'c_user', 'xs']
          
          fbCookies.forEach(cookieName => {
            // Cookie für aktuelle Domain löschen
            document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`
            
            // Cookie für Parent-Domain löschen (z.B. .example.com)
            const domain = window.location.hostname.split('.').slice(-2).join('.')
            document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.${domain}`
          })
          
          console.log('Facebook Cookies gelöscht')
        },
        
        disable() {
          this.isEnabled = false
          
          // Facebook Pixel deaktivieren
          if (window.fbq) {
            window.fbq('consent', 'revoke')
          }
          
          // Facebook Cookies löschen
          this.deleteFacebookCookies()
          
          console.log('Meta Pixel deaktiviert')
        },
        
        track(eventName, data = {}) {
          if (window.fbq && this.isEnabled) {
            window.fbq('track', eventName, data);
          }
        },

        trackCustom(eventName, data = {}) {
          if (window.fbq && this.isEnabled) {
            window.fbq('trackCustom', eventName, data);
          }
        },
        
        init(pixelId) {
          // Event-Listener für Consent-Änderungen
          window.addEventListener('cc:onConsent', () => {
            if (Vue.prototype.$cookieConsent.acceptedCategory('marketing')) {
              this.load(pixelId)
            } else {
              this.disable()
            }
          })
          
          window.addEventListener('cc:onChange', () => {
            if (Vue.prototype.$cookieConsent.acceptedCategory('marketing')) {
              this.load(pixelId)
            } else {
              this.disable()
            }
          })
          
          // Beim Start prüfen ob schon akzeptiert
          Vue.nextTick(() => {
            if (Vue.prototype.$cookieConsent.acceptedCategory('marketing')) {
              this.load(pixelId)
            }
          })
        }
      }
    }
  }